<div *ngIf="loaded" class="sts-recaptcha"> 
  <re-captcha 
    (resolved)="resolved($event)"
    [siteKey]="siteKey">
  </re-captcha>
</div>
